import { render, staticRenderFns } from "./ChangeStatusModal.vue?vue&type=template&id=6135aa0c&scoped=true&"
import script from "./ChangeStatusModal.vue?vue&type=script&lang=js&"
export * from "./ChangeStatusModal.vue?vue&type=script&lang=js&"
import style0 from "./ChangeStatusModal.vue?vue&type=style&index=0&id=6135aa0c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6135aa0c",
  null
  
)

export default component.exports